import { render, staticRenderFns } from "./edito-media.vue?vue&type=template&id=658e429c"
import script from "./edito-media.vue?vue&type=script&lang=js"
export * from "./edito-media.vue?vue&type=script&lang=js"
import style0 from "./edito-media.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ElementsEditoText: require('/home/node/app/components/elements/edito-text/edito-text.vue').default,ElementsUiWrapper: require('/home/node/app/components/elements/ui-wrapper/ui-wrapper.vue').default})
